<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        <v-col v-if="validateLoad==true" id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <v-row justify="center" align="center">
                <v-col calign-self="center" cols="auto">
                    <v-row justify="center" >
                        <v-progress-circular
                        :size="70"
                        :width="7"
                        :color="$store.state.colors.primary"
                        indeterminate
                        ></v-progress-circular>                        
                    </v-row> 
                </v-col>
            </v-row>
        </v-col>    
        <v-col v-else id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <!-- Back button -->
            <v-row justify="start" align="center" style="height:55px; background-color: #e6e6e6;" class="pt-0">
                <v-btn @click="$router.push({ name: 'userprofile'})" icon :color="$store.state.colors.primary">
                    <v-icon x-large >mdi-chevron-left</v-icon>
                </v-btn>
            </v-row>

            <v-row class="RestoRegular mt-5 pl-6 mb-4" style="height:40px; font-size: 25px; color: #4D4D4D;">
                Detalles del pedido
            </v-row>

            <!-- Order Card -->
            <v-row>
                <v-col style="width: 100%; color: #424242" class="pt-0">
                    <v-row class="pt-2" style="width: 95%; margin: 0 auto; border-bottom: 1px solid #E6E6E6;" align="center">
                        <img  :src="platillos[0].imagen == null ? require('@/assets/resources/yoomi/yoomy-screen.png'): platillos[0].imagen" style="width: 100%; height: 35vh; object-fit: cover; object-position: center;">
                    </v-row>
                    <v-row class="pl-2 pt-2" style="background-color: #E6E6E6; width: 95%; margin: 0 auto; border-bottom: 1px solid #E6E6E6; ">
                        <v-col align-self="start" cols="auto">
                            <v-img v-if="orderData.metodo_entrega == 'Entrega a domicilio'" src="@/assets/resources/user/casa.svg" max-width="25px"></v-img>
                            <v-img v-else src="@/assets/resources/user/restaurante.svg" max-width="25px"></v-img>
                        </v-col>
                        <v-col style="font-size: 12px" class="">
                            <v-row v-if="orderData.direccion != 'No existe' && orderData.metodo_entrega == 'Entrega a domicilio'" class="RestoBold" style="font-size: 13px">
                                Entregado en {{orderData.direccion[0].alias}}
                            </v-row>
                            <v-row v-if="orderData.direccion != 'No existe' && orderData.metodo_entrega == 'Recoger en restaurante'" class="RestoBold" style="font-size: 13px">
                                Entregado en sucursal {{orderData.sucursal}}
                            </v-row>
                            <v-row>
                                {{orderData.fecha_alta.substr(0,10)}}
                            </v-row>
                            <v-row>
                                No. de Pedido {{orderData.id_pedido}}
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row class="RestoRegular mb-0 pb-0" justify="end" style="font-size: 10px; line-height: 2px; background-color: #E6E6E6; width: 95%; margin: 0 auto;">
                        Cantidad
                    </v-row>

                    <v-row class="mt-0 pb-0" v-for="(platillo, index) in platillos" :key="index" style="font-size: 12px; border-bottom: 2px solid black; background-color: #E6E6E6; width: 95%; margin: 0 auto;">
                        <v-col align-self="center" class="ml-4">
                            <v-row class="RestoBold py-0 my-0" style="font-size: 13px" >
                                {{platillo.platillo}}
                            </v-row>
                            <v-row v-if="platillo.modificadores">
                                <v-col class="py-0 my-0">
                                    <v-row v-for="(modificado, index) in platillo.modificadores" :key="index" class="py-0 my-0 ml-2">
                                        <v-row v-if="modificado.unico" class="py-0 my-0 mb-2">
                                            <v-col class="py-0 my-0">
                                                <v-row v-for="(modificador, index) in modificado.unico" :key="index" >
                                                    {{modificador.modificador}}
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="modificado.cantidad" class="py-0 my-0 mb-2">
                                            <v-col class="py-0 my-0">
                                                <v-row v-for="(modificador, index) in modificado.cantidad" :key="index" >
                                                    {{modificador.modificador}} x{{modificador.cantidad}}
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="modificado.multiple" class="py-0 my-0 mb-2">
                                            <v-col class="py-0 my-0">
                                                <v-row v-for="(modificador, index) in modificado.multiple" :key="index" >
                                                    {{modificador.modificador}}
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <!-- <v-row v-if="platillo.modificadores[0].unico" class="py-0 my-0 mb-2">
                                <v-col class="py-0 my-0">
                                    <v-row v-for="(modificador, index) in platillo.modificadores" :key="index" >
                                        {{modificador.unico[0].modificador}}
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row v-if="platillo.modificadores[0].cantidad" class="py-0 my-0 mb-2">
                                <v-col class="py-0 my-0">
                                    <v-row v-for="(modificador, index) in platillo.modificadores[0].cantidad" :key="index" >
                                        {{modificador.modificador}}
                                    </v-row>
                                </v-col>
                            </v-row> -->
                            <v-row v-if="platillo.adicionales" class="py-0 my-0">
                                <v-col class="py-0 my-0 ml-2" >
                                    <v-row v-for="(adicional, index) in platillo.adicionales[0]" :key="index">
                                        {{adicional.adicional}} x{{adicional.cantidad}}
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="auto" align-self="center" >
                            <v-row justify="start">
                                {{productPriceN(platillo)}}
                            </v-row>
                        </v-col>
                        <v-col cols="auto" align-self="center" >
                            <v-row justify="center" align="center" style="width: 20px; margin: 0 auto" class="RestoBold">
                                <!-- <v-btn  max-width="30" icon>-</v-btn> -->
                                 {{platillo.cantidad}}
                                 <!-- <v-btn max-width="30px" icon>+</v-btn> -->
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row class="mt-0" style="background-color: #E6E6E6; width: 95%; margin: 0 auto;">
                        <v-col class="pl-12" style="font-size: 13px"> 
                            <!-- <v-row>
                                <v-col class="py-0 my-0 ml-2" >
                                    <v-row justify="start">
                                        Subtotal:
                                    </v-row>
                                </v-col>
                                <v-col class="py-0 my-0 mr-2">
                                    <v-row justify="end" style="font-size: 17px">
                                        {{total()}}
                                    </v-row>
                                </v-col> 
                            </v-row> 
                            <v-row>
                                <v-col class="py-0 my-0 ml-2">
                                    <v-row justify="start">
                                        Envío:
                                    </v-row>
                                </v-col>
                                <v-col class="py-0 my-0 mr-2">
                                    <v-row justify="end" style="font-size: 17px">
                                        $000.00
                                    </v-row>
                                </v-col> 
                            </v-row>  -->
                            <v-row style="font-size: 20px">
                                <v-col class="py-0 my-0 ml-2">
                                    <v-row justify="start" >
                                        Total:
                                    </v-row>
                                </v-col>
                                <v-col class="py-0 my-0 mr-2 RestoBold" align-self="center">
                                    <v-row justify="end" style="font-size: 17px;" :style="{'color': $store.state.colors.primary}">
                                        {{total()}}
                                    </v-row>
                                </v-col> 
                            </v-row> 
                        </v-col>
                    </v-row>
                    <v-row justify="center" style="background-color: #E6E6E6; width: 95%; margin: 0 auto; text-align: center; color: #4D4D4D " class="RestoRegular pb-0 mb-0">
                        <v-col class="pb-0 mb-0">
                            <v-textarea label="" :value="orderData.comentarios" background-color="white" disabled solo :color="$store.state.colors.primary" dense auto-grow rows="1" ></v-textarea>
                        </v-col>
                    </v-row>

                </v-col>
            </v-row>

        </v-col>
    </v-row>
</template>


<script>

export default {
    data() {
        return {
            idOrder:null,
            addresses: null,
            active: null,
            orderData: null,
            platillos: null,
            validateLoad:true,
        }
    },
    created() {
        this.idOrder=this.$route.params.id;
        this.$store.state.hideFooter = false;
        // console.log(this.$route.params.id);
        // console.log("EL OBJETO PLATILLO: ",this.$store.state.lista_platillos);
        this.$store.dispatch("GET", {url: 'detalle_ped/' + this.idOrder, headers: {Authorization: localStorage.getItem("token")}})
            .then(response => {
                console.log(response);
                this.orderData = response.data;
                this.platillos = response.data.platillos;
                // console.log("Received Order: ", this.orderData);
                // console.log("Received Platillos: ", this.platillos);
                this.validateLoad = false;
            })
            .catch(error => {
                console.log("Error: " + error);
            });
    },
    methods: {
        total() {
                // var suma = 0;
                // for(let platillo in this.platillos)
                // {
                //     // console.log(this.platillos[platillo].precio_unitario);
                //     suma += parseInt(this.platillos[platillo].precio_unitario);
                // }
                const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2
                })
                return formatter.format(this.orderData.monto_total);
                
        },
        productPriceN(product)
        {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2
                })
                return formatter.format(product.subtotal);
        },
        productPrice(product)
        {
            var adi = 0;
            var modi = 1;
            // console.log(product);
            var total = 0;
            if(product.adicionales)
            {
                for(var i = 0; i < product.adicionales[0].length; i++)
                    adi+= parseFloat(product.adicionales[0][i].precio_adicional*product.adicionales[0][i].cantidad);
            }
            if(product.modificadores){
                if(parseFloat(product.max_cant) == 0){
                    for(var j = 0; j < product.modificadores.length; j++){
                        modi+=product.modificadores[j].cantidad;
                    }
                }else{
                    modi=1;
                }
            }
            total = ((product.precio_unitario*modi) + adi) * product.cantidad;
            return total;
        },
    }
}
</script>

<style scoped>
    .rounded-btn{
       border-radius:20px;
    }

    .hidscroll {
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .active {
        color: white;
    }

</style>